<!-- cms outlet block -->
<icms-outlet-block [name]="'400page'"
                   [variant]="'404-page'"></icms-outlet-block>
